module.exports = __webpack_public_path__ + "494cd07c/img/trash-icon.ff8201c7.svg";